document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const toggle = () => {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  toggle();
  window.addEventListener('scroll', toggle, { passive: true });
});
